import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import SupportAgentRoundedIcon from '@mui/icons-material/SupportAgentRounded';

const CIANO = '#00E2F4';

// Tela mostrada quando o login foi válido mas a empresa está desativada no
// painel de controle (ver AuthContext.tsx > empresaInativa) — a mesma do
// FrontSIAC (Login.tsx > TelaEmpresaDesativada), sempre com a paleta escura,
// sem acompanhar o tema do PDV.
export const TelaEmpresaDesativada: React.FC<{ onVoltar: () => void }> = ({ onVoltar }) => (
  <Box
    sx={{
      width: '100%',
      height: '100dvh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '18px',
      textAlign: 'center',
      px: 3,
      background: 'linear-gradient(145deg, #003A50 0%, #002C3D 38%, #001E27 72%, #001720 100%)',
    }}
  >
    <SupportAgentRoundedIcon sx={{ fontSize: 56, color: CIANO }} />
    <Typography sx={{ color: '#FFFFFF', fontSize: '24px', fontWeight: 750, letterSpacing: '-0.02em' }}>
      Empresa desativada
    </Typography>
    <Typography sx={{ color: 'rgba(255, 255, 255, 0.66)', fontSize: '15px', maxWidth: 380, lineHeight: 1.6 }}>
      O acesso dessa empresa ao sistema está temporariamente desativado. Consulte o suporte para regularizar e voltar a usar o SIAC.
    </Typography>
    <Button
      variant="outlined"
      onClick={onVoltar}
      sx={{
        mt: '12px',
        borderRadius: '12px',
        textTransform: 'none',
        color: CIANO,
        borderColor: 'rgba(0, 226, 244, 0.4)',
        '&:hover': { borderColor: CIANO, background: 'rgba(0, 226, 244, 0.08)' },
      }}
    >
      Voltar para o login
    </Button>
  </Box>
);
